module.exports = __webpack_public_path__ + "img/bg_avatar_female_88.63727e19.png";